import React from 'react';
import LocationTemplate from './LocationTemplate';

const PowellsvillePage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Powellsville"
      stateName="North Carolina"
      countyName="Bertie"
      zipCodes={["27967"]}
      latitude={36.2649}
      longitude={-76.9952}
      population={179}
      historicalFact="Named after the Powell family, early settlers and landowners in Bertie County."
      nearbyTowns={[
        "Ahoskie, NC",
        "Aulander, NC",
        "Colerain, NC",
        "Windsor, NC",
        "Rich Square, NC",
        "Murfreesboro, NC",
        "Winton, NC",
        "Kelford, NC"
      ]}
    />
  );
};

export default PowellsvillePage;